export const GET_SITE_SETTINGS_DATA = 'GET_SITE_SETTINGS_DATA';
export const LOGGED_IN = 'LOGGED_IN';
export const LOG_OUT = 'LOG_OUT';
export const CART_LIST = 'CART_LIST';
export const CART_DELETE = 'CART_DELETE';
export const NOTIFICATION_COUNT = 'NOTIFICATION_COUNT';